import DivisionVisual from "../../components/ClassTwo/NumberMath/DivisionVisual";
import DivisionWord from "../../components/ClassTwo/NumberMath/DivisionWord";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-two/number-math/division/visual-problem", title: "Visual Problem", component: DivisionVisual },
    { url: "/class-two/number-math/division/word-problem", title: "Word Problem", component: DivisionWord }
];

export default topics;